module.exports = __webpack_public_path__ + "img/videoProducT.46d449ed.png";